 enum NotificationTypeEnum {
  success = 'success',
  error = 'error',
  info = 'info',
  warning = 'warning',
}

export default NotificationTypeEnum;
